/**
 * this closure provides methods that
 * interface with the storage API that
 * saves user data to local storage
 */
const _storageMethods = (function () {
    function Storage({ storage }) {
        /**
         * collate all form data from the completed
         * step and save it to local storage
         *
         * @return {void}
         */
        this.saveData = function () {
            if (this.active.nodeName.match(/form/i)) {
                const savedData = storage.get();
                const { section, name } = this.activeData;
                const formData = new FormData(this.active);
                const data = {};
                const question = this.active.querySelector(
                    `[data-role="question"]`
                );

                for (const key of formData.keys()) {
                    data[key] = formData.get(key);
                }

                if (question) {
                    data.mainQuestion = question.textContent;
                }

                savedData[section].questions[name] = data;

                storage.set(savedData);
            }
        };
    }

    return (props) => {
        return new Storage(props);
    };
})();

export default _storageMethods;
